<template>
	<div id="app">
		<navmenu />
		<router-view/>
		<footermenu />
	</div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style src="./assets/sass/styles.scss" lang="scss"></style>
